import { render, staticRenderFns } from "./ThresholdRateTable.vue?vue&type=template&id=25ce1023&scoped=true"
import script from "./ThresholdRateTable.vue?vue&type=script&lang=ts"
export * from "./ThresholdRateTable.vue?vue&type=script&lang=ts"
import style0 from "./ThresholdRateTable.vue?vue&type=style&index=0&id=25ce1023&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce1023",
  null
  
)

export default component.exports